<div class="list-filter-container">

  <form *ngIf="formGroup" [formGroup]="formGroup">

    <div class="house-filter flex-space-between" *ngIf="servicedHousesList">
      <lib-dropdown [items]="servicedHousesList"
                    [multi]="true"
                    [formControlName]="'servicedHousesList'">
      </lib-dropdown>

      <ng-content></ng-content>
    </div>

    <div class="flex-space-between">

      <lib-dropdown *ngIf="items && items.countSort"
                    [items]="items.countSort"
                    [formControlName]="'selectedCountSort'">
      </lib-dropdown>

      <lib-dropdown *ngIf="items && items.fieldSort"
                    [items]="items.fieldSort"
                    [formControlName]="'selectedFieldSort'">
      </lib-dropdown>

      <lib-lookup *ngIf="items && items.placeholder" [formControlName]="'search'"
                  [placeholder]="items.placeholder">
      </lib-lookup>

    </div>

  </form>

</div>
